<template>
    <div class="ibox-tools">
        <div class="pull-right m-b-sm">
            <v-btn v-if="current_selection_filter.length > 0 && current_selection_filter !== '-1' && (authSuperadmin === '1' || ownFilter.indexOf(current_selection_filter) > -1)"
                    type="button" class="btn btn-secondary m-r-sm" @click.stop.prevent="editDeleteFilterModal">
                <i class="fa-regular fa-pencil m-r-sm"></i>{{ t_edit_delete_filter }}
            </v-btn>
            <v-btn type="button" class="btn btn-w-m btn-secondary" @click.stop.prevent="newFilterModal">
                <i class="fa-regular fa-plus fa-lg m-r-xs"></i>
                {{ t_new_filter }}
            </v-btn>
        </div>
        <div class="col-md-2 pull-right no-padding m-r-sm">
            <select aria-label="select" :data-placeholder="t_select_filter" class="chosen-select filter" name="existing_filter">
                <option v-for="element in filter" :value="element.value">{{ element.label }}</option>
            </select>
        </div>
        <div class="pull-right">
            <v-btn v-if="current_selection_columnpreset.length > 0  && current_selection_columnpreset !== '-1' && authEdit === '1'"
                    type="button" class="btn btn-secondary m-r-sm" @click.stop.prevent="editDeleteColumnPresetModal">
                <i class="fa-regular fa-pencil m-r-sm"></i>{{ t_edit_delete_columnpreset }}
            </v-btn>
            <v-btn v-if="authEdit === '1'" type="button" class="btn btn-w-m btn-secondary m-r-sm" @click.stop.prevent="newColumnPresetModal">
                <i class="fa-regular fa-plus fa-lg m-r-xs"></i>
                {{ t_new_columnpreset }}
            </v-btn>
        </div>
        <div class="col-md-2 pull-right no-padding m-r-sm">
            <select aria-label="columns" :data-placeholder="t_select_columnpreset" class="chosen-select columns" name="existing_columns">
                <option v-for="element in columns" :value="element.value">{{ element.label }}</option>
            </select>
        </div>
    </div>
</template>
<script>
    export default {
        props: [
            'filter',
            'ownFilter',
            'columns',
            'authEdit',
            'authSuperadmin',
            'selectedFilter',
            'selectedColumn',
            'action_visibility'
        ],
        data() {
            return {
                t_edit_delete_filter: Lang.langGet("Edit / Delete Filter"),
                t_edit_delete_columnpreset: Lang.langGet("Edit / Delete Column Preset"),
                t_new_filter: Lang.langGet("New Filter"),
                t_new_columnpreset: Lang.langGet("New Column Preset"),
                t_select_filter: Lang.langGet("Select a filter..."),
                t_select_columnpreset: Lang.langGet("Select a Column Preset..."),
                current_selection_filter: this.selectedFilter,
                current_name_filter: '',
                current_selection_columnpreset: this.selectedColumn,
                current_name_columnpreset: ''
            }
        },
        watch: {
            filter: function(val, oldVal) {
                let changeVal = '';
                let select = $(this.$el).find('.chosen-select.filter');

                if(val.length < oldVal.length) {
                    let found = false;

                    val.forEach((element) => {
                        if(parseInt(element['value']) === parseInt(this.selectedFilter)) {
                            found = true;
                        }
                    });

                    if(found === true) {
                        changeVal = this.selectedFilter;
                    } else {
                        this.current_selection_filter = '';
                        this.current_name_filter = '';
                    }
                } else {
                    changeVal = this.selectedFilter;
                }

                this.$nextTick(function() {
                    select.val(changeVal).trigger('chosen:updated');
                    if(changeVal.length === 0) {
                        this.current_selection_filter = '';
                        this.current_name_filter = '';
                    } else {
                        this.current_selection_filter = changeVal;
                        this.current_name_filter = select.find('option:selected').text();
                    }
                    EaseEventBus.fire('loadedClientStatusFilter');
                });

                EaseEventBus.fire('updateTable', {preset: this.selectedColumn, filter: changeVal});
            },
            columns: function(val, oldVal) {
                let changeVal = '';
                let select = $(this.$el).find('.chosen-select.columns');

                if(val.length < oldVal.length) {
                    let found = false;

                    val.forEach((element) => {
                        if(parseInt(element['value']) === parseInt(this.selectedColumn)) {
                            found = true;
                        }
                    });

                    if(found === true) {
                        changeVal = this.selectedColumn;
                    } else {

                    }
                } else {
                    changeVal = this.selectedColumn;
                }

                this.$nextTick(function() {
                    select.val(changeVal).trigger('chosen:updated');
                    if(changeVal.length === 0) {
                        this.current_selection_columnpreset = '';
                        this.current_name_columnpreset = '';
                    } else {
                        this.current_selection_columnpreset = changeVal;
                        this.current_name_columnpreset = select.find('option:selected').text();
                    }
                    EaseEventBus.fire('loadedClientStatusColumnPreset');
                });

                EaseEventBus.fire('updateTable', {preset: changeVal, filter: this.selectedFilter});
            }
        },
        methods: {
            editDeleteFilterModal: function() {
                EaseEventBus.fire('showEditDeleteFilterModal', { name: this.current_name_filter, id: this.current_selection_filter });
            },
            editDeleteColumnPresetModal: function() {
                EaseEventBus.fire('showEditDeleteColumnPresetModal', { name: this.current_name_columnpreset, id: this.current_selection_columnpreset });
            },
            newFilterModal: function() {
                EaseEventBus.fire('showNewFilterModal');
            },
            newColumnPresetModal: function() {
                EaseEventBus.fire('showNewColumnPresetModal');
            },
            reset: function() {
                _.extend(this.$data, this.$options.data());
            }
        },
        mounted() {
            let selectFilter = $(this.$el).find('.chosen-select.filter');
            let selectColumns = $(this.$el).find('.chosen-select.columns');
            selectColumns.val(this.selectedColumn).trigger('chosen:updated');
            selectFilter.val(this.selectedFilter).trigger("chosen:updated");

            selectFilter.chosen().change(() => {
                this.current_selection_filter = selectFilter.val();
                this.current_name_filter = selectFilter.find('option:selected').text();
                EaseEventBus.fire('updateTable', {preset: selectColumns.val(), filter: selectFilter.val()});
                axios.get('/cache/clientstatusfilter/'+selectFilter.val());
            });

            selectColumns.chosen().change(() => {
                this.current_selection_columnpreset = selectColumns.val();
                this.current_name_columnpreset = selectColumns.find('option:selected').text();
                EaseEventBus.fire('updateTable', {preset: selectColumns.val(), filter: selectFilter.val()});
                axios.get('/cache/clientstatuscolumn/'+selectColumns.val());
            });

            // check for -1 and '' because if no entry in the cache exists the value gets set to ''
            if (!(this.selectedFilter === '-1' || this.selectedFilter === '') ||
                !(this.selectedColumn === '-1' || this.selectedColumn === '')) {
                this.$emit('update:action_visibility', true);
                EaseEventBus.fire('FilterOrPresetWasSetClientStatus');
            }

            EaseEventBus.listen('triggerUpdateTable', () => {
                EaseEventBus.fire('updateTable', {preset: this.current_selection_columnpreset, filter: this.current_selection_filter});
            });

            EaseEventBus.listen('setNewClientStatusFilterAsCurrent', (data) => {
                this.filter.forEach((element) => {
                    if (element.label === data.name) {
                        selectFilter.val(_.toString(element.value)).trigger("chosen:updated");
                        this.current_selection_filter = selectFilter.val();
                        this.current_name_filter = selectFilter.find('option:selected').text();
                        EaseEventBus.fire('updateTable', {preset: null, filter: selectFilter.val()});
                        axios.get('/cache/clientstatusfilter/' + selectFilter.val());
                    }
                })
            })

            EaseEventBus.listen('setNewClientStatusColumnPresetAsCurrent', (data) => {
                this.columns.forEach((element) => {
                    if (element.label === data.name) {
                        selectColumns.val(_.toString(element.value)).trigger("chosen:updated");
                        this.current_selection_columnpreset = selectColumns.val();
                        this.current_name_columnpreset = selectColumns.find('option:selected').text();
                        EaseEventBus.fire('updateTable', {preset: selectColumns.val(), filter: null});
                        axios.get('/cache/clientstatuscolumn/' + selectColumns.val());
                    }
                })
            })
        }
    }
</script>
